import * as Header from '../components/header';
import { Browser } from '../utils/browsercheck';
import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function deleteEmptyPTags() {
    // Lösche leere p Tags mit Leerzeichen
    for (const p of document.querySelectorAll('#main p')) {
        if (p.innerHTML.replace(/\s| |&nbsp;/g, '') === '') {
            p.remove();
        }
    }
}

function addExternalLinkClass() {
    const not = ':not(.social-link)';

    /** @type {NodeListOf<HTMLAnchorElement>} */
    const links = document.querySelectorAll(`a[href^="http://"]${not}, a[href^="https://"]${not}`);

    for (const a of links) {
        if (!a.hostname.endsWith(location.hostname) && !a.parentElement.classList.contains('image_container')) {
            a.classList.add('external-link');
        }
    }
}

function setCustomProperties() {
    const footer = document.getElementById('footer');

    document.body.style.setProperty('--header-height', `${Header.getHeight(true)}px`);
    document.documentElement.style.setProperty('--scrollbar-width', `${Browser.scrollbarWidth}px`);
    document.body.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
}

function setTouchDeviceClass() {
    if (Browser.isTouchDevice()) {
        document.documentElement.classList.add('touch');
    }
}

function fullHeight() {
    for (const img of document.querySelectorAll('.full-height img')) {
        img.style.height = `calc(100vh - ${Header.getHeight()}px)`;
    }
}

function scrollToAnchor() {
    for (const a of document.querySelectorAll('a[href*="#"]')) {
        a.addEventListener('click', function (e) {
            ScrollUtil.scrollToAnchor(e, this);
        });
    }
}

function addLoadingClassToImages() {
    /** @type {NodeListOf<HTMLImageElement>} */
    const images = document.querySelectorAll('img:not([href$=".svg"]');

    images.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
            return;
        }

        if (img.hasAttribute('width')) {
            img.style.setProperty('--loading-width', `${img.getAttribute('width')}px`);
        }

        img.classList.add('loading');
        img.addEventListener('load', () => img.classList.remove('loading'));
        // img.onload = () => img.classList.remove('loading');
    });
}

/**
 * Seite einblenden wenn sie fertig geladen ist
 */
function fadeInSite() {
    const loader = document.getElementById('page-loader');

    if (loader) {
        loader.classList.add('hide');
    }

    setTimeout(() => document.documentElement.classList.replace('loading', 'loaded'), 400);
}

/**
 * Calculate scale factor so a rotated box fits into its original size
 * @param {number} w - original width
 * @param {number} h - original height
 * @param {number} sin
 * @param {number} cos
 * @returns {number} scale factor
 */
function getFitScale(w, h, sin, cos) {
    // const angle = (angleDeg * Math.PI) / 180; // convert to radians

    const rotatedWidth = Math.abs(w * cos) + Math.abs(h * sin);
    const rotatedHeight = Math.abs(w * sin) + Math.abs(h * cos);

    const scaleX = w / rotatedWidth;
    const scaleY = h / rotatedHeight;

    return Math.min(scaleX, scaleY);
}

function calculateImageGroups() {
    document.querySelectorAll('.image-group').forEach((imgGroup) => {
        let groupHeight = 0;

        imgGroup.querySelectorAll('.rotate img').forEach((elem, index) => {
            let width = elem.width;
            let height = elem.height;
            const style = window.getComputedStyle(elem);
            const transform = style.transform;
            // Parse matrix values
            const values = transform
                .match(/matrix\(([^)]+)\)/)[1]
                .split(',')
                .map(parseFloat);

            let scale = getFitScale(width, height, values[0], values[1]);
            elem.style.transform = `${transform} scale(${scale})`;
            if (index < 2) {
                groupHeight += height;
            }
        });

        console.log(imgGroup);
        console.log(imgGroup.style.height);
        imgGroup.style.height = groupHeight + 'px';
        console.log(imgGroup.style.height);
    });
}

onDomReady(() => {
    addLoadingClassToImages();
    addExternalLinkClass();
    deleteEmptyPTags();
    setCustomProperties();
    setTouchDeviceClass();
    fullHeight();
    scrollToAnchor();
    calculateImageGroups();
});

window.addEventListener('load', () => {
    fadeInSite();
    setCustomProperties();

    ScrollUtil.scrollToAnchor(null, window.location);
});

window.addEventListener('resize', () => {
    fullHeight();
    setCustomProperties();
    calculateImageGroups();
});
